import React from 'react';
import './styles.css';
import BasicButton from '../../../../components/BasicButton';
import BasicButtonGroup from '../../../../components/BasicButtonGroup';

const FiltersPartial = ({
  title,
  subTitle,
  accordions,
  disabled,
  hideControls,
  onClearAll,
  compact = false,
}) => {
  const disableAction = () => {};

  return (
    <div className="filters-accordion-partial">
      <div
        className={
          !compact
            ? 'filters-accordion-partial__header'
            : 'filters-accordion-partial__header filters-accordion-partial__header--compact'
        }
      >
        <label className="filters-accordion-partial__title">{title}</label>
        {subTitle && (
          <p className="filters-accordion-partial__description">{subTitle}</p>
        )}
      </div>

      <div className="filters-accordion-partial__filters-list">
        {accordions}
      </div>

      {!hideControls && (
        <div className="filters-accordion-partial__controls">
          <BasicButtonGroup>
            <BasicButton
              controlFunc={disabled ? disableAction : onClearAll}
              btnWidth={150}
              btnHeight={35}
              btnFontWeight={500}
              btnFontSize="0.8571rem"
              btnArrow={false}
              btnTextColor="#27282d"
              btnText="Clear filters"
            />
          </BasicButtonGroup>
        </div>
      )}
    </div>
  );
};

export default FiltersPartial;
